module.exports = __webpack_public_path__ + "static/img/value01.9911346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/value01.png
// module id = bjMQ
// module chunks = 0